module.exports = __webpack_public_path__ + "static/img/shengtaixitong.0b20140.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shengtaixitong.png
// module id = hEuv
// module chunks = 1